import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button, Box } from '@material-ui/core';
import { useAuthLocation } from '../../auth/hooks/useAuthLocation';
import ErrorTemplate from '../ErrorTemplate';
import './../Error.scss';

const Unauthorized = () => {
  const { userLogout } = useAuthLocation();
  const { t } = useTranslation();

  return (
    <ErrorTemplate>
      <Typography className="info__primary" variant="h1">
        {t('error.401.title')}
      </Typography>
      <Typography className="info__secondary" variant="h2">
        {t('error.401.content')}
      </Typography>
      <Box className="info__bnt">
        <Button
          className="bnt"
          variant="contained"
          size="large"
          onClick={() => {
            userLogout();
          }}
        >
          {t('auth.logout')}
        </Button>
      </Box>
    </ErrorTemplate>
  );
};

export default Unauthorized;
